import React, { useState, useEffect } from 'react';
import axios from '../../api/api';

const Reports = () => {

  const [clients, setClients] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedClient, setSelectedClient] = useState(false);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [downloading, setDownloading] = useState(false);

  // Fetch clients based on search query
  useEffect(() => {
    setLoading(true);
    if (searchQuery.length > 2 && !selectedClient) {
      const fetchClients = async () => {
        try {
          const response = await axios.get(`/clients/?company_name=${searchQuery}`);
          setClients(response.data.items);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      };
      fetchClients();
    } else {
      setClients([]);
      setLoading(false)
    }
  }, [searchQuery, selectedClient]);

  const handleClientSelect = (client) => {
    setSearchQuery(client.company_name);
    setSelectedClient(client.id); 
    setClients([])
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    if (e.target.value.length === 0) {
      setSelectedClient(false); 
    } else if (!selectedClient) {
      setSelectedClient(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedClient) {
      alert("Please select a client from the list");
      return;
    }

    if (!startDate || !endDate) {
      alert("Please select both start and end dates");
      return;
    }

    try {
      setDownloading(true);

      const response = await axios.get(
        `/request_log/reports/${selectedClient}/${startDate}/${endDate}`,
        {
          responseType: "blob",
        }
      );

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // Use filename from backend if available
      const disposition = response.headers["content-disposition"];
      let filename = "report.xlsx";

      if (disposition) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match) filename = match[1];
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert("Failed to download report.");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className='mx-auto p-4'>
      <h4 className="my-2"><b>Download Reports</b></h4>

      <div className='bg-white rounded-lg p-4 w-full'>
        <form onSubmit={handleSubmit}>
          <div className="flex flex-wrap items-start gap-2">
            <label htmlFor="client">
              <input
                type='text'
                placeholder='Type company name...'
                className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] w-full rounded-md focus:ring-1'
                value={searchQuery}
                onChange={handleSearchChange}
              />
              {loading ? (
                <span>Loading...</span>
              ) : (
                clients.length > 0 && (
                  <ul className='bg-white border border-gray-300 w-full rounded-md shadow-md max-h-40 overflow-y-auto z-10'>
                    {clients.map((client) => (
                      <li
                        key={client.id}
                        className='p-2 hover:bg-gray-200 cursor-pointer'
                        onClick={() => handleClientSelect(client)}
                      >
                        {client.company_name}  <span className='text-blue-600 font-bold text-xl'>-</span> 
                        {client.email_address}
                      </li>
                    ))}
                  </ul>
                )
              )}
            </label>
            <label htmlFor="startDate">
              <span className='hidden'>Start Date</span>
              <input 
                type="date"
                className='px-3 py-2 border bg-[#f2f9ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
                value={startDate}
                onChange={(e) => {setStartDate(e.target.value)}}
              />
            </label>
            <label htmlFor="endDate">
              <span className='hidden'>End Date</span>
              <input 
                type="date" 
                className='px-3 py-2 border bg-[#f2f9ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#165277] focus:ring-[#165277] focus:ring-1'
                value={endDate}
                onChange={(e) => {setEndDate(e.target.value)}}
              />
            </label>
            <button type='submit' className='bg-[#134463] text-white px-4 py-2 rounded-lg hover:bg-[#165277]'>{downloading ? 'Downloading...' : 'Download Report'}</button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default Reports
